import { createContext } from 'react';
export const GiftcardContext = createContext();